<div class="modal-header has-close">
  <div class="modal-title">
    <img src="assets/icons/ic-otp@3x.svg" alt="" />
    <span>Verify it’s you</span>
  </div>
  <button
    type="button"
    class="close"
    aria-label="Close"
    (click)="activeModal.dismiss()"
  >
    <img src="assets/icons/ic-close@3x.svg" alt="" />
  </button>
</div>
<div class="modal-body">
  <div class="otp-instruction">
    Enter the One Time Password (OTP) sent to
    {{ maskedMobileNumber | uppercase }}
  </div>
  <div
    class="fna-otp-input-wrapper"
    (keydown.enter)="isCTAEnabled ? submitOTP() : null"
  >
    <ng-otp-input
      #ngOtpInput
      (onInputChange)="onOtpChange($event)"
      [config]="{
        length: numberOfInputs,
        allowNumbersOnly: true,
        inputClass: 'fna-otp-input ' + (isError ? 'otp-error ' : ''),
        containerClass: otpWrapperClass
      }"
    ></ng-otp-input>
    <div *ngIf="isError" class="error">
      You have entered an invalid OTP. Please try again
    </div>
  </div>
  <div class="bottom-wrapper">
    <div class="otp-message">
      <div *ngIf="!otpExpire; else resend_otp">
        Resend OTP in
        <countdown
          class="countdown-timer"
          [config]="{ format: 'mm:ss', leftTime: otpExpiryInSeconds }"
          (event)="handleCountdownTimer($event)"
        ></countdown>
      </div>
      <ng-template #resend_otp>
        <span class="blue-link" (click)="resendOTP()">Resend OTP</span>
      </ng-template>
    </div>
    <div class="desktop-button-wrapper">
      <app-primary-button (click)="submitOTP()" [disabled]="!isCTAEnabled">
        Okay
      </app-primary-button>
    </div>
  </div>
</div>
<div class="modal-footer mobile-button-wrapper">
  <app-primary-button (click)="submitOTP()" [disabled]="!isCTAEnabled">
    Okay
  </app-primary-button>
</div>
